enum ButtonSize {
  Small = 'small',
  Medium = 'medium',
  Other = 'other',
}

export default ButtonSize;
